import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyInboxAssistant: FunctionComponent<{
  showFeedbackCollector: () => void;
}> = ({ showFeedbackCollector }) => {
  const InboxAssistant = useLazyComponent(
    () => import(/* webpackChunkName: "inbox-assistant" */ './InboxAssistant'),
    { namedImport: 'InboxAssistant' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Inbox Assistant',
      }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <InboxAssistant showFeedbackCollector={showFeedbackCollector} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
